import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  useTheme
} from '@mui/material'
import usePWAEvents from '../../hooks/usePWAEvents'
import usePwaUpdateCopy from '../../hooks/use-pwa-update-copy'

/**
 * Modale aggiornamento PWA + snackbar prima visita (offline ready).
 */
export default function SwUpdateModal() {
  const theme = useTheme()
  const copy = usePwaUpdateCopy()
  const titleColor =
    theme.palette.newColors?.gray || theme.palette.text.primary
  const secondaryColor = theme.palette.text.secondary
  const cancelColor =
    theme.palette.newColors?.gray || theme.palette.text.secondary
  const primarySx = {
    background:
      theme.palette.newColors?.cyanGradient || theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      background:
        theme.palette.newColors?.cyanGradient || theme.palette.primary.dark
    }
  }

  const {
    showUpdateAvailable,
    showOfflineReady,
    applyUpdate,
    dismissUpdate,
    dismissOfflineReady
  } = usePWAEvents()

  const showUpdateDialog =
    showUpdateAvailable && process.env.NODE_ENV === 'production'

  return (
    <>
      <Dialog
        open={showUpdateDialog}
        onClose={dismissUpdate}
        aria-labelledby="pwa-update-dialog-title"
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 'var(--radius-2xl, 12px)'
          }
        }}
      >
        <DialogTitle
          id="pwa-update-dialog-title"
          sx={{
            color: titleColor,
            fontWeight: 600,
            pb: 1
          }}
        >
          {copy.title}
        </DialogTitle>
        <DialogContent sx={{ pt: 0 }}>
          <DialogContentText
            component="div"
            sx={{ color: secondaryColor, lineHeight: 1.5 }}
          >
            {copy.body}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, pt: 0, gap: 1 }}>
          <Button onClick={dismissUpdate} sx={{ color: cancelColor }}>
            {copy.later}
          </Button>
          <Button
            onClick={applyUpdate}
            variant="contained"
            autoFocus
            sx={primarySx}
          >
            {copy.reload}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showOfflineReady}
        autoHideDuration={6000}
        onClose={dismissOfflineReady}
        message={copy.offlineReady}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </>
  )
}
